import moment from 'moment';
import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import Spinner from '../../components/common/Spinner';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { walletsNFTWithdraw } from '../../helpers/helperFunctions';
import { AuthLayoutTitle } from '../../styles/GlobalComponents';

import { CaptionText } from '../../styles/FontStyles';
import { SelectWalletSignIn } from '../Login/SelectWalletSignIn/SelectWalletSignIn';
import { useAccount, useSignMessage, useDisconnect } from 'wagmi';
import { useAppKit } from '@reown/appkit/react';

import { WalletNFTType } from '../../types/types';

import { PROFILE_DETAILS } from '../../routes/routes';
import axios from 'axios';
import { setUserRegisterToLS } from '../../helpers/localstorage-helper';
import {
  storeWalletAddress,
  storeWalletAddressSign
} from '../../slices/auth-slice';

type TParams = { childPosition?: string; id?: string };

const ConnectWallet = ({ history }: RouteComponentProps<TParams>) => {
  const dispatch = useAppDispatch();

  const { disconnect } = useDisconnect();

  const { address, isConnected, connector } = useAccount();

  const [loadingConnect, setLoadingConnect] = useState(false);

  const { loading } = useAppSelector((state) => state.auth);

  const { approvalDate, referrerId } = useAppSelector(
    (state) => state.auth.register
  );

  const { open } = useAppKit();

  const connectWallet = () => {
    /* METAMASK */

    if (!isConnected) {
      open({ view: 'Connect' });
    }
  };

  const continueToProfile = () => {
    checkIfWalletExist();
  };

  const { signMessageAsync } = useSignMessage();

  const getWalletAddresSignature = async () => {
    try {
      setLoadingConnect(true);
      const { data } = await axios.get(
        `/authorization/signup/wallet?walletAddress=${address}`
      );
      const message = data.data.challenge;
      const signature = await signMessageAsync({ connector, message });

      dispatch(storeWalletAddress(address));
      dispatch(storeWalletAddressSign(signature));

      setUserRegisterToLS({
        referrerId,
        approvalDate,
        walletAddress: address,
        walletAddressSign: signature
      });

      setLoadingConnect(false);
      history.push(PROFILE_DETAILS);
    } catch (error: any) {
      disconnect();

      setLoadingConnect(false);
      ErrorToast(error?.response?.data.error);
    }
  };

  const checkIfWalletExist = async () => {
    try {
      setLoadingConnect(true);
      await axios.get(`/authorization/signup/wallet/check`, {
        params: {
          walletAddress: address
        }
      });

      getWalletAddresSignature();
      setLoadingConnect(false);
    } catch (error: any) {
      setLoadingConnect(false);
      ErrorToast(error?.response?.data.error);
    }
  };

  useEffect(() => {
    // disconnect();
  }, [isConnected]);

  return (
    <>
      {(loading || loadingConnect) && <Spinner fullScreen={true} transparent />}
      <AuthLayoutTitle>
        {isConnected ? 'You’re connected!' : 'Connect Your Wallet'}{' '}
      </AuthLayoutTitle>

      {!isConnected && (
        <CaptionText mb='20'>Pick your wallet to get started.</CaptionText>
      )}

      {isConnected && (
        <InputBackOffice type={'text'} disabled value={address} />
      )}
      <Button
        m='20px 0 10px 0'
        onClick={() => (isConnected ? continueToProfile() : connectWallet())}>
        {isConnected ? 'Continue' : 'Connect Wallet'}
      </Button>

      <Button
        m='20px 0 10px 0'
        onClick={() => {
          disconnect();
          history.push(PROFILE_DETAILS);
        }}>
        Connect wallet later
      </Button>
    </>
  );
};

export default ConnectWallet;
